/*
  Gallery section slider
*/

export function gallerySectionSlider() {
  $('.gallery-section.v1').each(function () {
    $(this).find('.gallery-wrapper').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: true,
      adaptiveHeight: true,
      cellAlign: 'left',
    });

    $(this).find('.flickity-button').appendTo($(this).find('.pagination-control'));
  });
}